export default "__VITE_ASSET__5214145d__"